import React, { memo } from 'react';
import useLabelSmartPosition from '../hooks/useLabelSmartPosition';

const PlusIcon = ({ size = 11 }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none" aria-hidden="true">
    <line x1="6" y1="1" x2="6" y2="11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <line x1="1" y1="6" x2="11" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const SignalHoverCard = memo(
  ({ yVal, x, y, onAdd, onMouseEnter, onMouseLeave }) => {
    const { ref, pos } = useLabelSmartPosition(x, y);
    const displayVal =
      yVal !== undefined && yVal !== null
        ? String(Math.round(yVal * 10) / 10)
        : '—';

    return (
      <div
        ref={ref}
        className="leg-hover-anchor"
        style={{ left: pos.left, top: pos.top, visibility: pos.visibility }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div className="leg-signal-popup">
          <div className="leg-signal-row">
            <span className="leg-signal-meta">Valeur</span>
            <span className="leg-signal-val leg-signal-val--bold">{displayVal}</span>
          </div>
          <button
            className="leg-btn-add-signal"
            onClick={onAdd}
            title="Ajouter un label à ce point"
          >
            <PlusIcon size={11} />
            Ajouter un label
          </button>
        </div>
      </div>
    );
  }
);

export default SignalHoverCard;
